// extracted by mini-css-extract-plugin
export default {"container":"styles_container__uHmAv","azureMediaPlayerWrapper":"styles_azureMediaPlayerWrapper__vqJJZ","text":"styles_text__mttL2"};